import { createContext, useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { getAuthInstance } from "./firebase/firebase";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword, signOut, onAuthStateChanged } from "firebase/auth";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // ── Login real con Firebase ──────────────────────────────────────────────────
  const loginAuth = async (email, password) => {
    setIsLoading(true);
    try {
      const authInst = await getAuthInstance();

      await signInWithEmailAndPassword(authInst, email, password);

      Swal.fire({
        title: "¡Bienvenido!",
        text: "Acceso concedido.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false
      });

      setIsLoading(false);
      navigate("/panelAdmin");

    } catch (error) {
      console.error("Error in login:", error);

      Swal.fire({
        title: "Acceso denegado",
        text: "Correo electrónico o contraseña incorrectos.",
        icon: "error",
      });
      setIsLoading(false);
    }
  };

  // ── Logout real con Firebase ─────────────────────────────────────────────────
  const logout = async () => {
    try {
      const authInst = await getAuthInstance();
      await signOut(authInst);
      setCurrentUser(null);
      localStorage.clear();
      navigate("/login");
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  // ── Observador de estado de sesión ───────────────────────────────────────────
  useEffect(() => {
    let unsubscribe;

    const setupAuthObserver = async () => {
      try {
        const authInst = await getAuthInstance();

        unsubscribe = onAuthStateChanged(authInst, (user) => {
          if (user) {
            setCurrentUser(user);
          } else {
            setCurrentUser(null);
          }
        });
      } catch (error) {
        console.error("Error al configurar el observador de auth:", error);
      }
    };

    setupAuthObserver();

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);

  const value = {
    currentUser,
    loginAuth,
    logout,
    isLoading
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

